"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _date_area_component = _interopRequireDefault(require("./date_area_component"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiTimepicker = _interopRequireDefault(require("@tencent/spaui-timepicker"));

var _spauiButton = _interopRequireDefault(require("@tencent/spaui-button"));

var _index = require("../utils/index");

var _shortcut_panel = _interopRequireDefault(require("../panel/shortcut_panel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPE = 'single';

var UseShortcut = function UseShortcut() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = props.children,
      useShortcut = props.useShortcut,
      nowDateObject = props.nowDateObject,
      shortcuts = props.shortcuts,
      optionalStartDateData = props.optionalStartDateData,
      optionalEndDateData = props.optionalEndDateData,
      onChange = props.onChange,
      _props$classNameMap = props.classNameMap,
      classNameMap = _props$classNameMap === void 0 ? {} : _props$classNameMap,
      _props$locale = props.locale,
      locale = _props$locale === void 0 ? {} : _props$locale,
      setLabel = props.setLabel;
  var result = null;

  if (useShortcut) {
    result = _react["default"].createElement("div", null, _react["default"].createElement("div", {
      className: "clearfix"
    }, children), _react["default"].createElement("div", {
      className: "clearfix ".concat(classNameMap.DatePickerFastControlClassName)
    }, _react["default"].createElement(_shortcut_panel["default"], {
      locale: locale,
      setLabel: setLabel,
      classNameMap: classNameMap,
      type: TYPE,
      nowDateObject: nowDateObject,
      shortcuts: shortcuts,
      optionalStartDateData: optionalStartDateData,
      optionalEndDateData: optionalEndDateData,
      onChange: onChange
    })));
  } else {
    result = children;
  }

  return result;
}; // 获取时分秒


var getHourMinuteSecond = function getHourMinuteSecond() {
  var timePickerProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultCheckedDate = arguments.length > 1 ? arguments[1] : undefined;
  var hourList = timePickerProps.hourList,
      minuteList = timePickerProps.minuteList,
      secondList = timePickerProps.secondList,
      timeList = timePickerProps.timeList;
  var tempTimeArr = [];
  var tempHour = '';
  var tempMinute = '';
  var tempSecond = '';

  if ((0, _spauiUtils.isArray)(timeList) && timeList.length > 0) {
    tempTimeArr = timeList[0].split(':');
    tempHour = tempTimeArr[0] || '';
    tempMinute = tempTimeArr[1] || '';
    tempSecond = tempTimeArr[2] || '';
  } else {
    tempHour = (0, _spauiUtils.isArray)(hourList) && hourList.length > 0 ? hourList[0] : defaultCheckedDate.getHours();
    tempMinute = (0, _spauiUtils.isArray)(minuteList) && minuteList.length > 0 ? minuteList[0] : defaultCheckedDate.getMinutes();
    tempSecond = (0, _spauiUtils.isArray)(secondList) && secondList.length > 0 ? secondList[0] : defaultCheckedDate.getSeconds();
  }

  return {
    hour: tempHour || '00',
    minute: tempMinute || '00',
    second: tempSecond || '00'
  };
};
/**
 * @class
 */


var SingleDatePanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SingleDatePanel, _PureComponent);

  function SingleDatePanel(props) {
    var _this;

    _classCallCheck(this, SingleDatePanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleDatePanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleDateAreaComponentChangeWhenHaveTimePicker", function (event, type) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$props = _this.props,
          onRealtimeChange = _this$props.onRealtimeChange,
          optionalStartDateData = _this$props.optionalStartDateData,
          optionalEndDateData = _this$props.optionalEndDateData;
      var year = data.year,
          month = data.month,
          date = data.date;
      var _this$state = _this.state,
          tempYear = _this$state.tempYear,
          tempMonth = _this$state.tempMonth,
          tempDate = _this$state.tempDate;
      var _this$state2 = _this.state,
          tempHour = _this$state2.tempHour,
          tempMinute = _this$state2.tempMinute,
          tempSecond = _this$state2.tempSecond;
      var limitTime = optionalStartDateData.hour > 0 || optionalStartDateData.minute > 0 || optionalStartDateData.second > 0 || typeof optionalEndDateData.hour !== 'undefined';

      if (tempYear !== year || tempMonth !== month || tempDate !== date) {
        // 限制时间的话，切换就清空
        if (limitTime) {
          tempHour = '';
          tempMinute = '';
          tempSecond = '';
        }

        _this.setState({
          tempYear: year,
          tempMonth: month,
          tempDate: date,
          tempHour: tempHour,
          tempMinute: tempMinute,
          tempSecond: tempSecond
        });

        if ((0, _spauiUtils.isFunction)(onRealtimeChange)) {
          onRealtimeChange(event, TYPE, {
            year: year,
            month: month,
            date: date,
            hour: tempHour,
            minute: tempMinute,
            second: tempSecond
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeDisplayedStartYear", function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'forward';
      var displayedStartYear = _this.state.displayedStartYear;
      var newDisplayedStartYear = displayedStartYear;

      if (type === 'backward') {
        newDisplayedStartYear = displayedStartYear - 10;
      } else if (type === 'forward') {
        newDisplayedStartYear = displayedStartYear + 10;
      }

      var newDisplayedEndYear = newDisplayedStartYear + 11;

      _this.setState({
        displayedStartYear: newDisplayedStartYear,
        displayedEndYear: newDisplayedEndYear
      });
    });

    _this.state = _objectSpread({}, _this.getDefaultStateData(props.dateData, props.empty, true));
    _this.handleTimePickerChange = _this.handleTimePickerChange.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SingleDatePanel, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!(0, _spauiUtils.isUndefined)(nextProps.dateData)) {
        this.setState(this.getDefaultStateData(nextProps.dateData, nextProps.empty));
      }
    } // 根据当前的dateData数据拆分获取年月日时分秒的数据及初始化数据

  }, {
    key: "getDefaultStateData",
    value: function getDefaultStateData() {
      var dateData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var empty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props2 = this.props,
          optionalStartDateObject = _this$props2.optionalStartDateObject,
          optionalEndDateObject = _this$props2.optionalEndDateObject,
          nowDateObject = _this$props2.nowDateObject,
          _this$props2$timePick = _this$props2.timePickerProps,
          timePickerProps = _this$props2$timePick === void 0 ? {} : _this$props2$timePick,
          optionalStartDateData = _this$props2.optionalStartDateData,
          optionalEndDateData = _this$props2.optionalEndDateData,
          picker = _this$props2.picker,
          year = _this$props2.year;
      var state = this.state || {};
      var limitTime = optionalStartDateData.hour > 0 || optionalStartDateData.minute > 0 || optionalStartDateData.second > 0 || typeof optionalEndDateData.hour !== 'undefined';
      var tempYear = dateData.year || 0;
      var tempMonth = dateData.month || 0;
      var tempDate = dateData.date || 0;
      var tempHour = typeof dateData.hour !== 'undefined' ? dateData.hour : '';
      var tempMinute = typeof dateData.minute !== 'undefined' ? dateData.minute : '';
      var tempSecond = typeof dateData.second !== 'undefined' ? dateData.second : '';
      var hourMinuteSecondData = {};
      var defaultDate = null; // 如果是年份选择器，每一页只显示12个

      var displayedStartYear = state.displayedStartYear || optionalStartDateData.year;
      var displayedEndYear = state.displayedEndYear || optionalEndDateData.year;

      if (!empty) {
        if (!limitTime) {
          // 如果不在选择范围的话，就用最小的那天，否则就用今天
          if (nowDateObject.getTime() >= optionalStartDateObject.getTime() && nowDateObject.getTime() <= optionalEndDateObject.getTime()) {
            defaultDate = nowDateObject;
          } else {
            defaultDate = optionalStartDateObject;
          } // 没有选中日期，给个默认展示的日期


          if (!tempYear && !tempMonth && !tempDate) {
            tempYear = defaultDate.getFullYear();
            tempMonth = defaultDate.getMonth();
            tempDate = defaultDate.getDate();
          } // 没有时分秒也给一个


          if (!tempHour && !tempMinute && !tempSecond) {
            hourMinuteSecondData = getHourMinuteSecond(timePickerProps, defaultDate);
            tempHour = hourMinuteSecondData.hour;
            tempMinute = hourMinuteSecondData.minute;
            tempSecond = hourMinuteSecondData.second;
          }
        }
      } else {
        // empty为空全部清除
        tempYear = 0;
        tempMonth = 0;
        tempDate = 0;
        tempHour = '';
        tempMinute = '';
        tempSecond = '';
      } // 年份选择的话需要分页


      if (picker === 'year' && isInit) {
        // 计算下这个年所在面板的可选开始时间
        displayedStartYear = year - year % 10 - 1;
        displayedEndYear = displayedStartYear + 11;
      }

      return {
        tempYear: tempYear,
        tempMonth: tempMonth,
        tempDate: tempDate,
        tempHour: tempHour,
        tempMinute: tempMinute,
        tempSecond: tempSecond,
        displayedStartYear: displayedStartYear,
        displayedEndYear: displayedEndYear
      };
    } // 有时分秒选择的日期组件面板回调，因为有确定按钮，所以这里保存的是一个临时状态

  }, {
    key: "handleTimePickerChange",
    // 时分秒选择组件回调
    value: function handleTimePickerChange(event) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props3 = this.props,
          onRealtimeChange = _this$props3.onRealtimeChange,
          empty = _this$props3.empty;
      var timeArr = value.split(':') || [];
      var _this$state3 = this.state,
          tempYear = _this$state3.tempYear,
          tempMonth = _this$state3.tempMonth,
          tempDate = _this$state3.tempDate;
      var defaultData = {};
      var data = {}; // 如果已经被临时清空了，需要重新获取年月日

      if (empty) {
        defaultData = this.getDefaultStateData(this.props.dateData);
        tempYear = defaultData.tempYear;
        tempMonth = defaultData.tempMonth;
        tempDate = defaultData.tempDate;
      }

      data = {
        tempYear: tempYear,
        tempMonth: tempMonth,
        tempDate: tempDate,
        tempHour: timeArr[0] || 0,
        tempMinute: timeArr[1] || 0,
        tempSecond: timeArr[2] || 0
      };
      this.setState(data);

      if ((0, _spauiUtils.isFunction)(onRealtimeChange)) {
        onRealtimeChange(event, TYPE, {
          year: data.tempYear,
          month: data.tempMonth,
          date: data.tempDate,
          hour: data.tempHour,
          minute: data.tempMinute,
          second: data.tempSecond
        });
      }
    } // 提交选择的数据

  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this$state4 = this.state,
          tempYear = _this$state4.tempYear,
          tempMonth = _this$state4.tempMonth,
          tempDate = _this$state4.tempDate,
          tempHour = _this$state4.tempHour,
          tempMinute = _this$state4.tempMinute,
          tempSecond = _this$state4.tempSecond;
      var onChange = this.props.onChange;

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, TYPE, {
          year: tempYear,
          month: tempMonth,
          date: tempDate,
          hour: tempHour,
          minute: tempMinute,
          second: tempSecond
        });
      }
    } // 获取时分秒组件的值

  }, {
    key: "getTimeValue",
    value: function getTimeValue() {
      var _this$state5 = this.state,
          tempHour = _this$state5.tempHour,
          tempMinute = _this$state5.tempMinute,
          tempSecond = _this$state5.tempSecond;
      var _this$props$timePicke = this.props.timePickerProps,
          timePickerProps = _this$props$timePicke === void 0 ? {} : _this$props$timePicke;
      var timeList = timePickerProps.timeList;
      var result = '';
      var tempArray = []; // 添加时分秒，且都加0

      if ((0, _index.addZero)(tempHour)) {
        tempArray.push((0, _index.addZero)(tempHour));

        if ((0, _index.addZero)(tempMinute)) {
          tempArray.push((0, _index.addZero)(tempMinute));

          if ((0, _index.addZero)(tempSecond)) {
            tempArray.push((0, _index.addZero)(tempSecond));
          }
        }
      }

      result = tempArray.join(':'); // 如果有timeList，初始化时会用第一个做数据转化，所以这里替换成原来的item数据

      result = (0, _index.getRowDataByTimeList)(timeList, result);
      return result;
    }
  }, {
    key: "showTimePickerTitle",
    value: function showTimePickerTitle() {
      var timePickerProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props$locale = this.props.locale,
          locale = _this$props$locale === void 0 ? {} : _this$props$locale;
      var showSecond = !(0, _spauiUtils.isEmptyObject)(timePickerProps);
      return _react["default"].createElement("ul", {
        className: (0, _classnames["default"])('spaui-datepicker-timepicker-title clearfix', {
          'timepicker-title-with-second': showSecond
        })
      }, _react["default"].createElement("li", null, locale.hourLabel), _react["default"].createElement("li", null, locale.minuteLabel), showSecond ? _react["default"].createElement("li", null, locale.secondLabel) : null);
    }
    /**
     * 年份面板的切换
     * @param {*} type 切换的类型
     */

  }, {
    key: "render",
    value: function render() {
      var _this$state6 = this.state,
          tempYear = _this$state6.tempYear,
          tempMonth = _this$state6.tempMonth,
          tempDate = _this$state6.tempDate,
          displayedStartYear = _this$state6.displayedStartYear,
          displayedEndYear = _this$state6.displayedEndYear;
      var _this$props4 = this.props,
          picker = _this$props4.picker,
          _onChange = _this$props4.onChange,
          dateData = _this$props4.dateData,
          optionalStartDateData = _this$props4.optionalStartDateData,
          optionalEndDateData = _this$props4.optionalEndDateData,
          timePicker = _this$props4.timePicker,
          _this$props4$timePick = _this$props4.timePickerProps,
          timePickerProps = _this$props4$timePick === void 0 ? {} : _this$props4$timePick,
          onOpen = _this$props4.onOpen,
          clear = _this$props4.clear,
          useShortcut = _this$props4.useShortcut,
          shortcuts = _this$props4.shortcuts,
          type = _this$props4.type,
          nowDateObject = _this$props4.nowDateObject,
          onYearAndMonthChange = _this$props4.onYearAndMonthChange,
          year = _this$props4.year,
          month = _this$props4.month,
          _this$props4$classNam = _this$props4.classNameMap,
          classNameMap = _this$props4$classNam === void 0 ? {} : _this$props4$classNam,
          panelWeekStart = _this$props4.panelWeekStart,
          hideSubmitButton = _this$props4.hideSubmitButton,
          _this$props4$locale = _this$props4.locale,
          locale = _this$props4$locale === void 0 ? {} : _this$props4$locale,
          setLabel = _this$props4.setLabel,
          firstDayOfWeek = _this$props4.firstDayOfWeek,
          endDayOfWeek = _this$props4.endDayOfWeek,
          fixedTips = _this$props4.fixedTips,
          fixedNumber = _this$props4.fixedNumber,
          MonthPanelListComponent = _this$props4.MonthPanelListComponent,
          YearPanelListComponent = _this$props4.YearPanelListComponent;
      var timeValue = this.getTimeValue(); // 日期面板的属性

      var dateAreaComponentProps = {
        MonthPanelListComponent: MonthPanelListComponent,
        YearPanelListComponent: YearPanelListComponent,
        nowDateObject: nowDateObject,
        optionalStartDateData: optionalStartDateData,
        optionalEndDateData: optionalEndDateData,
        year: year,
        month: month,
        type: TYPE,
        picker: picker,
        onYearAndMonthChange: onYearAndMonthChange,
        classNameMap: classNameMap,
        panelWeekStart: panelWeekStart,
        useShortcut: useShortcut,
        timePicker: timePicker,
        hideSubmitButton: hideSubmitButton,
        locale: locale,
        setLabel: setLabel,
        displayedStartYear: displayedStartYear,
        displayedEndYear: displayedEndYear,
        firstDayOfWeek: firstDayOfWeek,
        endDayOfWeek: endDayOfWeek,
        fixedTips: fixedTips,
        fixedNumber: fixedNumber,
        onChangeDisplayedStartYear: this.onChangeDisplayedStartYear
      };
      var limitTime = optionalStartDateData.hour > 0 || optionalStartDateData.minute > 0 || optionalStartDateData.second > 0 || typeof optionalEndDateData.hour !== 'undefined';
      var result = null;
      var disabled = false;
      var startTimePickerBeginTime = '';
      var startTimePickerEndTime = '';
      var timePickerBeginTime = '';
      var timePickerEndTime = ''; // 如果允许清空，就不进行确定按钮disabled

      if (clear) {
        disabled = false;
      } else {
        disabled = timePicker ? !(tempDate && timeValue) : !tempDate;
      }

      if (timePicker) {
        if (typeof optionalStartDateData.hour !== 'undefined') {
          timePickerBeginTime = [optionalStartDateData.hour || '00', optionalStartDateData.minute || '00', optionalStartDateData.second || '00'].join(':');
        }

        if (typeof optionalEndDateData.hour !== 'undefined') {
          timePickerEndTime = [optionalEndDateData.hour || '00', optionalEndDateData.minute || '00', optionalEndDateData.second || '00'].join(':');
        } // 选择了最开始或者最末尾的那天，就得看下小时的选择是否限制下选项


        if (dateData.year === optionalStartDateData.year && dateData.month === optionalStartDateData.month && dateData.date === optionalStartDateData.date) {
          startTimePickerBeginTime = timePickerBeginTime;
        }

        if (dateData.year === optionalEndDateData.year && dateData.month === optionalEndDateData.month && dateData.date === optionalEndDateData.date) {
          startTimePickerEndTime = timePickerEndTime;
        }
      } // 没有时分秒面板


      if (!timePicker) {
        result = _react["default"].createElement(UseShortcut, {
          locale: locale,
          setLabel: setLabel,
          classNameMap: classNameMap,
          useShortcut: useShortcut,
          nowDateObject: nowDateObject,
          shortcuts: shortcuts,
          optionalStartDateData: optionalStartDateData,
          optionalEndDateData: optionalEndDateData,
          onChange: function onChange(event, data) {
            return _onChange(event, type, data);
          }
        }, _react["default"].createElement(_date_area_component["default"], _extends({}, dateAreaComponentProps, {
          classNameMap: classNameMap,
          className: "clearfix",
          onChange: _onChange,
          dateData: dateData
        })));
      } else {
        var withAllTime = timePicker && timePickerProps && timePickerProps.config && timePickerProps.config.hour && timePickerProps.config.minute && timePickerProps.config.second;
        var needTimePickerTitle = timePicker && (withAllTime || (0, _spauiUtils.isEmptyObject)(timePickerProps)); // 有时分秒面板大单日期目前不支持快捷选择，主要是样式不支持，如果样式支持了，套上UseShortcut就可以了

        result = _react["default"].createElement("div", null, _react["default"].createElement("div", {
          className: "clearfix"
        }, _react["default"].createElement(_date_area_component["default"], _extends({}, dateAreaComponentProps, {
          onChange: this.handleDateAreaComponentChangeWhenHaveTimePicker,
          dateData: {
            year: tempYear,
            month: tempMonth,
            date: tempDate
          }
        })), timePicker ? _react["default"].createElement("div", {
          className: (0, _classnames["default"])(classNameMap.DatePickerTimePickerClassName, {
            'with-all-time': withAllTime,
            'with-timepicker-title': needTimePickerTitle
          })
        }, limitTime && !dateData.year ? _react["default"].createElement("div", {
          className: "".concat(classNameMap.DatePickerTimePickerTipClassName, " ").concat(classNameMap.DatePickerSingleDateTimePickerTipClassName)
        }, "\u8BF7\u5148\u9009\u62E9\u65E5\u671F") : _react["default"].createElement("div", null, needTimePickerTitle ? this.showTimePickerTitle(timePickerProps) : null, _react["default"].createElement(_spauiTimepicker["default"], _extends({}, timePickerProps, {
          beginTime: startTimePickerBeginTime,
          endTime: startTimePickerEndTime,
          value: timeValue,
          showPlaceholder: false,
          onChange: this.handleTimePickerChange,
          show: true
        })))) : null), _react["default"].createElement("div", {
          className: "clearfix ".concat(classNameMap.DatePickerFastControlClassName)
        }, _react["default"].createElement(_spauiButton["default"], {
          displayType: "primary",
          onClick: this.handleSubmit,
          disabled: disabled
        }, locale.submitLabel), _react["default"].createElement(_spauiButton["default"], {
          displayType: "default",
          onClick: onOpen
        }, locale.cancelLabel)));
      }

      return result;
    }
  }]);

  return SingleDatePanel;
}(_react.PureComponent);

var _default = SingleDatePanel;
exports["default"] = _default;